import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class TicketIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">

				<path fill="currentColor" d="M260 492c-11.040 0-20 8.96-20 20s8.96 20 20 20 20-8.96 20-20c0-11.040-8.96-20-20-20z"></path>
				<path fill="currentColor" d="M1004 412c11.044 0 20-8.956 20-20v-120c0-33.084-26.916-60-60-60h-904c-33.084 0-60 26.916-60 60v120c0 11.044 8.954 20 20 20 55.14 0 100 44.86 100 100s-44.86 100-100 100c-11.046 0-20 8.956-20 20v120c0 33.084 26.916 60 60 60h904c33.084 0 60-26.916 60-60v-120c0-11.044-8.956-20-20-20-55.14 0-100-44.86-100-100s44.86-100 100-100zM864 512c0 70.406 52.244 128.842 120 138.576v101.424c0 11.028-8.972 20-20 20h-684v-60c0-11.044-8.954-20-20-20s-20 8.956-20 20v60h-180c-11.028 0-20-8.972-20-20v-101.424c67.756-9.734 120-68.17 120-138.576s-52.244-128.842-120-138.576v-101.424c0-11.028 8.972-20 20-20h180v60c0 11.044 8.954 20 20 20s20-8.956 20-20v-60h684c11.028 0 20 8.972 20 20v101.424c-67.756 9.734-120 68.17-120 138.576z"></path>
				<path fill="currentColor" d="M764 372h-344c-11.046 0-20 8.956-20 20s8.954 20 20 20h344c11.044 0 20-8.956 20-20s-8.956-20-20-20z"></path>
				<path fill="currentColor" d="M764 492h-344c-11.046 0-20 8.956-20 20s8.954 20 20 20h344c11.044 0 20-8.956 20-20s-8.956-20-20-20z"></path>
				<path fill="currentColor" d="M764 612h-344c-11.046 0-20 8.956-20 20s8.954 20 20 20h344c11.044 0 20-8.956 20-20s-8.956-20-20-20z"></path>
				<path fill="currentColor" d="M260 372c-11.046 0-20 8.956-20 20v40c0 11.044 8.954 20 20 20s20-8.956 20-20v-40c0-11.044-8.954-20-20-20z"></path>
				<path fill="currentColor" d="M260 572c-11.046 0-20 8.956-20 20v40c0 11.044 8.954 20 20 20s20-8.956 20-20v-40c0-11.044-8.954-20-20-20z"></path>

			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}
